import React, { FC, useEffect, useState } from "react";
import { Account } from "react-aad-msal";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { SofView } from "../../models";
import { State } from "../../store";
import ActivitiesPane from "./ActivitiesPane";
import LineHandlingPane from "./LineHandlingPane";
import queryString from "query-string";
import StatusBar from "./StatusBar";
import * as ActivityLogsStore from "../../store/ActivityLogsStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as OfflineDataStore from "../../store/OfflineDataStore";
import * as ProcessFlowConfigStore from "../../store/ProcessFlowConfigStore";
import * as SofViewStore from "../../store/SofViewStore";
import ActivitiesGrid from "./ActivitiesGrid";

export type ISofProps = ActivityLogsStore.ActivityLogsState &
  GeneralStore.GeneralState &
  LineHandlingStore.LineHandlingState &
  OfflineDataStore.OfflineDataState &
  ProcessFlowConfigStore.ProcessFlowConfigState &
  SofViewStore.SofViewState &
  typeof ActivityLogsStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  typeof OfflineDataStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof SofViewStore.actionCreators & {
    account: Account;
  } & typeof GeneralStore.actionCreators;
const SofPage: FC<ISofProps> = (props: ISofProps) => {
  const { lineHandling } = props;
  const { lineHandlingNo } = useParams() as any;
  //const [lineHandlingNo, setLineHandlingNo] = useState<string>();
  const [nominationNo, setNominationNo] = useState<string>();
  const [activityView, setActivityView] = useState(0);
  const history = useHistory();

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;

    setNominationNo(nominationno);

    if (props.processFlowConfigs.result === undefined) {
      props.getAllConfigs(true);
    }

    props.setSofView(nominationno ? SofView.Nomination : SofView.LineHandling);
    props.getActivityLogs(lineHandlingNo, () => {
      props.getLineHandling(
        lineHandlingNo,
        nominationno,
        false,
        false,
        () => {}
      );
    });
  }, []);

  useEffect(() => {
    if (props.nomination) {
      setActivityView(props.nomination.activityView);
    } else if (props.lineHandling.result) {
      setActivityView(props.lineHandling.result.activityView);
    }
  }, [props.lineHandling, props.nomination]);

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;

    if (nominationno) {
      props.setActiveNomination(nominationno);
      props.setSofView(SofView.Nomination);
    } else {
      if (lineHandling.result && lineHandling.result.processFlowConfigId) {
        props.setSofView(SofView.LineHandling);
        props.setActiveConfig(
          lineHandling.result.processFlowConfigId,
          lineHandling.result.processFlowConfigVersion
        );
        props.deleteActiveNomination();
      }
    }
  }, [history.location]);

  // useEffect(() => {
  //   props.setPageTitle("Marine Nominations");
  // }, []);

  return (
    <div style={{ height: "100%" }}>
      {lineHandlingNo && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <LineHandlingPane {...props}>
            <div
              style={{
                width: "65%",
                background: "white",
                position: "relative",
              }}
            >
              {activityView === 0 && (
                <ActivitiesPane
                  {...props}
                  className="pane-card h-100"
                  lineHandlingNo={lineHandlingNo}
                  nominationNo={nominationNo}
                />
              )}
              {activityView === 1 && <ActivitiesGrid {...props} />}
            </div>
          </LineHandlingPane>
        </div>
      )}
      <div style={{ background: "#fff", height: "auto" }}>
        {/* <StatusBar {...props} className="" /> */}
      </div>
    </div>
  );
};

export default connect(
  (state: State) => ({
    ...state.activityLogs,
    ...state.authentication,
    ...state.general,
    ...state.lineHandling,
    ...state.offlineData,
    ...state.processFlowConfigState,
    ...state.sofView,
  }),
  {
    ...ActivityLogsStore.actionCreators,
    ...LineHandlingStore.actionCreators,
    ...OfflineDataStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...GeneralStore.actionCreators,
  }
)(SofPage as any);
